/**
 * Constants for Firebase collection names used in the support feature
 */

// Main collections
export const SUPPORT_TICKETS_COLLECTION = 'support_tickets';

// Sub-collections
export const SUPPORT_MESSAGES_COLLECTION = 'messages';
export const SUPPORT_TYPING_STATUS_COLLECTION = 'typing_status';
